import { mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  name: "symbol-in-table",
  components: {},
  props: [],
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      userSetting: types.userSetting.getters.GET_USER_SETTING
    })
  },
  mounted() {},
  methods: {}
};
